import { render, staticRenderFns } from "./CruiseListViewCard.vue?vue&type=template&id=954f9228"
import script from "./CruiseListViewCard.vue?vue&type=script&lang=js"
export * from "./CruiseListViewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports